<template>
    <!-- 選擇旅遊國家功能 -->
    <div id="insureCount">
        <div class="count" v-for="(insure, index) in insureCount" :key="index">
            <label>{{ insure.title }}</label>
            <div class="countBtn">
                <img src="../../assets/minus.svg" @click="minusCount(index)" alt="minus">
                <p>{{ insure.count }}</p>
                <img src="../../assets/plus.svg" @click="plusCount(index)" alt="plus">
            </div>
        </div>
    </div>
</template>

<script setup>
import {onMounted, ref} from "vue";

    const props = defineProps({
        initInsureCount: Array
    })
    const emits = defineEmits(["clickCount"]);
    const insureCount = ref([
        {
            title: "長者(滿70歲-未滿80歲)",
            count: 0,
            rosterType:2,
        },
        {
            title: "大人(滿18歲-未滿70歲)",
            count: 0,
            rosterType:1,
        },
        {
            title: "青少年(滿15歲-未滿18歲)",
            count: 0,
            rosterType:5,
        },
        {
            title: "兒童(滿7歲-未滿15歲)",
            count: 0,
            rosterType:3,
        },
        {
            title: "幼童(0歲-未滿7歲)",
            count: 0,
            rosterType:4,
        },
    ]);
    const plusCount = (index) =>{
            var counts = 0
            insureCount.value.forEach(insure => {
                counts += insure.count;
            })
            if (counts < 4) {
                insureCount.value[index].count++;
                emits('clickCount', insureCount.value);
            }
        }
    const minusCount = (index)=>{
            var counts = 0
            insureCount.value.forEach(insure => {
                counts += insure.count;
            })
            if (insureCount.value[index].count > 0 && counts > 0) {
                insureCount.value[index].count--;
                emits('clickCount', insureCount.value);
            }
        }
    onMounted(()=>{
        if(props.initInsureCount){
            insureCount.value = props.initInsureCount;
        }
    })

</script>

<style lang="scss">
#insureCount {
    position: absolute;
    background: #FFFFFF;
    border: 1px solid $gray;
    border-top: 0;
    border-radius: 10px;
    width: 100%;
    z-index: 100;
    box-sizing: border-box;
    padding: 0 15px 10px;
    font-size: 14px;

    .card-header {
        &::after {
            content: "";
            display: block;
            border-bottom: 1px solid $gray-400;
            margin: 10px 0;
            width: 100%;
        }
    }

    .count {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 16px;
        font-weight: 500;
        color: $textColor;
        margin:8px 0;
        width: calc(100% - 16px);

        @media screen and (max-width: $small) {
            width: calc(100% - 30px);
            margin:10px 0;
        }
    }

    .countBtn {
        display: flex;
        border: 1px solid $btnGray;
        border-radius: $radius;
        padding: 5px 5px;
        margin: 3px;

        p {
            padding: 0 10px;
            @media screen and (max-width: $small) {
                padding:0 7px;
            }
        }

        img {
            cursor: pointer;
        }
    }

}
</style>